import { render, staticRenderFns } from "./Retention.vue?vue&type=template&id=5b2b2694&scoped=true&"
import script from "./Retention.vue?vue&type=script&lang=js&"
export * from "./Retention.vue?vue&type=script&lang=js&"
import style0 from "./Retention.vue?vue&type=style&index=0&id=5b2b2694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b2694",
  null
  
)

export default component.exports